
import * as ipxRuntime$6HvIbDz6ZX from '/home/forge/shop.ullmax.com/releases/81023597/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 767,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536,
    "mob375": 375,
    "mob390": 390,
    "mob414": 414,
    "desk": 1024,
    "deskStd": 1372,
    "deskLarge": 1600,
    "deskLargest": 1920
  },
  "presets": {
    "standard": {
      "modifiers": {
        "format": "webp",
        "quality": 70,
        "densities": "1x 2x"
      }
    }
  },
  "provider": "ipx",
  "domains": [
    "ullmax.centraqa.com",
    "ullmax-wp.imgix.net",
    "ullmax-shop.imgix.net",
    "cdn.ullmax.app"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$6HvIbDz6ZX, defaults: {} }
}
        